import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { EventCountCommand } from '../../../../commands/accounts/create.account.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
    ConfirmModalActions,
    ConfirmModalData
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { ShowPlacesCountModalData } from './show.places.count.modal.provider';

@Component({
    templateUrl: './show.places.count.modal.component.html',
    styleUrls: ['./show.places.count.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ShowPlacesCountModalComponent extends BaseComponent {
    public loading = false;
    public total = 0;
    public approved = 0;
    public unApproved = 0;
    public account: ShowPlacesCountModalData;
    public eventCount = new EventCountCommand();
    public editorChoiceCount: { eventChoice, placeChoice };
    public itemCount: ItemCount;
    @ViewChild('success') success: SuccessWrapComponent;

    constructor(private fb: FormBuilder,
                private accountApiService: AccountApiService,
                private modalService: ModalService,
                private alertify: AlertifyService,
                private dialogRef: MatDialogRef<ShowPlacesCountModalComponent>,
                data: ShowPlacesCountModalData) {
        super();
        this.account = Object.assign({}, data);
    }

    ngOnInit() {
        this.loading = true;
        // this.accountApiService.getPlaceCount(this.account.account.userName)
        //     .finally(() => {
        //         this.loading = false;
        //     })
        //     .subscribe((count) => {
        //         if (count && !isNullOrUndefined(count.total) && !isNullOrUndefined(count.approved) && !isNullOrUndefined(count.unApproved)) {
        //             this.total = count.total;
        //             this.approved = count.approved;
        //             this.unApproved = count.unApproved;
        //         }
        //     });
        this.getItemCount();
        this.getEventCount();
        // this.getEditorChoiceCount();
    }

    public getEventCount() {
        this.accountApiService.getEventCount(this.account.account.userName).subscribe((count: EventCountCommand) => {
            this.eventCount = count;
        });
    }

    public getEditorChoiceCount() {
        this.accountApiService.getEditorChoiceCount(this.account.account.userName).subscribe((count: { eventChoice, placeChoice }) => {
            this.editorChoiceCount = count;
        });
    }

    public getItemCount() {
        this.accountApiService.getItemCount(this.account.account.userName).subscribe((count: ItemCount) => {
            console.log(count);
            this.itemCount = count;
            this.itemCount.pdfHistory.forEach(x => {
                x.exportTime = new Date(x.exportTime).toLocaleString();
            });
            this.loading = false;
        });
    }

    public deletePlaces($event: ButtonTriggerEvent) {
        let actions = <ConfirmModalActions>{
            confirm: (event: ButtonTriggerEvent) => {
                this.accountApiService.removePlaces(this.account.account._id)
                    .finally(() => {
                        event.complete();
                        $event.complete();
                    })
                    .subscribe(() => {
                        this.alertify.successfully('Remove all places for this account');
                        this.close();
                    });
            },
            cancel: () => {
                $event.complete();
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: `Are you sure you want to delete all places for ${this.account.account.userName}, this cannot be reverted?`,
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    close() {
        this.dialogRef.close();
    }
}

export class ItemCount {
    public accountAnalytics: {
        tripPlanner: {
            eventClickCount,
            placeClickCount,
            tourClickCount,
            userTripClickCount,
            shareClickCount,
        } };
    public place: { total, approved, unApproved };
    public choice: { eventChoice, placeChoice };
    public pinned: { event, place };
    public tour: {
        tourItemCount,
        active,
        inActive,
        details: {
            title,
            isActive,
            shareCount,
            downloadPDFCount
        }[]
    };
    public pdfHistory: {
        category,
        downloadType,
        exportTime,
        feedType,
        hubName,
        version,
        itemExportCount
    }[];
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/show.places.count/show.places.count.modal.component.ts